import { usePunditUserContext } from "@circle-react/contexts/punditUserContext";

/**
 * Path to the community's root/home surface, for shell chrome that needs
 * to send the user "back to the community" (e.g. Admin Settings' TopBar
 * action, the mobile bottom nav's Home button, or a non-admin bouncing off
 * a settings page they can't stay on).
 *
 * Communities without Feed enabled (`home_page_enabled: false`) fall back
 * to "/spaces" rather than "/".
 */
export const useCommunityRootPath = () => {
  const { currentCommunity } = usePunditUserContext();
  return currentCommunity?.home_page_enabled ? "/feed" : "/spaces";
};
